import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import axios from "axios";
import './inspectionDetails.css';
import { getAuthToken } from '../../utils/authStorage';

const InspectionDetails = () => {
  const { inspectionId } = useParams();
  const [inspection, setInspection] = useState(null);
   const location = useLocation();
  const { projectName, inspectionName, clientName, projectId } = location.state || {};
  const [images, setImages] = useState([]);
  const navigate = useNavigate();
   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const token = getAuthToken();
    const fetchInspection = async () => {
      const res = await axios.get(`/api/inspections/${inspectionId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInspection(res.data);
      setImages(Array.isArray(res.data.images) ? res.data.images : []); // si vienen anidadas
    };
    fetchInspection();
  }, [inspectionId]);


  return (
    <div className="inspectionsContainer">
      <div className="titleContainer">
        <h2>InspectionnName: {inspection?.name}</h2>
      </div>


      <h3>Images:</h3>

      <div className="imageGrid">
        {images.map((img) => (
          <div key={img.id} className="imageItem">
            <img
              src={
                img.analysed && img.image_with_boxes_path
                  ? img.image_with_boxes_path
                  : img.id
              }
              alt={img.imageName}
              width="300"
            />
            <p>{img.imageName}</p>
            {img.analysed ? (
              <span className="badge badge-success">Analyzed</span>
            ) : (
              <span className="badge badge-warning">Pending</span>
            )}
          </div>
        ))}
      </div>
      {/* <ul>
        {Array.isArray(images) && images.map((img) => (
          <li key={img.id}>{img.imageName}</li>
        ))}
      </ul> */}

      <button onClick={() => navigate(`/inspections/${inspectionId}/upload`, {
        state: {
          projectId,
          projectName,
          inspectionId,
          inspectionName,
          clientName

        }
      })}>Upload images</button>
    </div>
  );
};

export default InspectionDetails;
